import React, { Component } from 'react';
import { connect } from 'react-redux';
import WaterGrid from "./WaterGrid";
// import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import AccountingListSearchComponentfrom from "./Search";
import WaterPlan from "./Plan";
import WaterSetting from "./Setting";
import WaterConsumption from "./Consumption";
import WaterSearch from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import * as Water from './Saga/Water';
interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    get_rent_contract_accounting: any,
    get_kyousais: any,

}



interface State {
    modalcontract: boolean
    // state types
    gamen: number,
}

class CustomerList extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);



        this.togglecontract = this.togglecontract.bind(this);



        this.state = {
            modalcontract: false,
            gamen: 0,



        }



    }





    componentWillMount() {
        this.props.get_kyousais()
        // this.props.customerNewDispSet(0)
        this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    submit(state: any) {
        console.log(state)

        this.props.get_kyousais(state)
    }
    togglecontract(e: any) {

        this.setState(prevState => ({
            modalcontract: !prevState.modalcontract,

        }));
        return
    }
    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }

    change(num: any) {
        this.setState({ gamen: num });
    }

    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12"
                //  style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        {/* <AccountingListSearchComponentfrom /> */}
                        {this.state.gamen === 0 ?
                            <WaterPlan />
                            : this.state.gamen === 1 ?
                                <WaterConsumption />
                                : this.state.gamen === 2 ?
                                    <WaterSetting />
                                    : this.state.gamen === 3 ?
                                        <WaterSearch />
                                        : ""
                        }

                        {/* <WaterSetting /> */}
                        {/* <WaterSearch /> */}
                        {/* <WaterConsumption /> */}
                        <button
                            type="button"
                            onClick={() => this.change(1)}
                        >水道使用量
                </button>
                        <button
                            type="button"
                            onClick={() => this.change(2)}
                        >水道検針物件設定
                </button>
                        <button
                            type="button"
                            onClick={() => this.change(3)}
                        >水道検針物件設定(詳細画面)
                </button>

                    </div>

                </div>

                {/* <div className="item-outer col-lg-12" style={{ display: (this.props.customerNewDisp === 1) ? '' : 'none' }}>
                    <div className="item">
           
                    </div>
                </div> */}


                <div className="item-outer col-lg-12"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        <WaterGrid togglecontract={this.togglecontract} />
                    </div>
                </div>


                <Modal isOpen={this.state.modalcontract} toggle={this.togglecontract} size="lg" fade={false}>

                    <ModalHeader toggle={this.togglecontract}>契約検索</ModalHeader>
                    <ModalBody>
                        <ContractSearchComponent />
                    </ModalBody>
                    <ModalFooter>
                        {/* <button className="btn btn btn-danger" style={{margin:"5px"}} onClick={this.delete_introductions}>削除する</button>*/}
                        <button className="btn btn btn-secondary" style={{ margin: "5px" }} onClick={this.togglecontract}>キャンセル</button>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
        banks: state.rentContractMoniesReducer.banks,
    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        // customerList(search:any) {
        //     dispatch(customerList(search))
        // },
        // customerNewDispSet(state:number) {
        //     dispatch(customerNewDispSet(state))
        // },
        // get_rent_contract_accounting(state:any) {
        //     dispatch(Monies.get_rent_contract_accounting(state))
        // },
        get_kyousais(state: any) {
            dispatch(Water.get_waters(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);




